import React from "react";
import Marquee from "react-fast-marquee";
import { SITE } from "../../../lib/siteData";

export default function CarriersStrip() {
  return (
    <section
      className="py-12 sm:py-14 bg-white border-b border-[#011233]/10"
      data-testid="carriers-section"
    >
      <Marquee
        gradient
        gradientColor="#FFFFFF"
        gradientWidth={140}
        speed={42}
        pauseOnHover
      >
        {SITE.carriers.map((c, i) => (
          <div
            key={c.src}
            className="mx-12 flex items-center"
            data-testid={`carrier-logo-${i}`}
          >
            <img
              src={c.src}
              alt="Insurance carrier"
              className="h-16 sm:h-20 w-auto object-contain"
              style={{ mixBlendMode: c.blend || "multiply" }}
            />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
